angular.module('core')
    .service('dblUsageFactory', [function() {
        return {
            extractUsageData: function(data) {
                var result = {
                    // usage time
                    usageTime: data.total_session_time,
                    averageUsageTime: data.average_weekly_session_time,
                    usageTimeStatus: data.average_weekly_session_time_status,
                    // lessons completed
                    lessonsCompleted: data.count_lessons_completed,
                    averageLessonsCompleted: data.average_weekly_lessons,
                    lessonsCompletedStatus: data.average_weekly_lessons_status,
                    // growth
                    standardsGrowth: data.standards_growth,
                    standardsPartialGrowth: data.standards_partial_growth,
                    percentGrowth: data.percent_growth,
                    percentGrowthStatus: data.percent_growth_status
                };
                return result;
            }
        };
    }]);
